/**
 * Validates that an external link does not reference ordersave.com or the restaurant's own domain
 *
 * Return Validation Result:
 * {
 * valid: Boolean,
 * errors: String[]
 * }
 * @param {string} activeDomain - The restaurant's active domain
 * @returns {Function} Validation Function
 */
const externalLink = (activeDomain) => (valueToValidate) => {
  const validResponse = {
    errors: [],
    valid: true,
  }

  // If no value, it's valid (required validator handles empty values)
  if (!valueToValidate) {
    return validResponse
  }

  // Parse the URL to safely extract the hostname
  let hostname
  try {
    const url = new URL(valueToValidate)
    hostname = url.hostname.toLowerCase()
  } catch (e) {
    // If URL is malformed, let the url validator handle it
    return validResponse
  }

  // Check if hostname is ordersave.com or any subdomain
  if (hostname === 'ordersave.com' || hostname.endsWith('.ordersave.com')) {
    return {
      errors: ['External links cannot point to ordersave.com'],
      valid: false,
    }
  }

  // Check if hostname is the restaurant's own domain without a subdomain
  // Block bare domain (example.com or www.example.com)
  // Other subdomains are allowed (e.g., shop.example.com is OK)
  if (activeDomain) {
    const domainLower = activeDomain.toLowerCase()

    // Block exact match or www. subdomain
    if (hostname === domainLower || hostname === `www.${domainLower}`) {
      return {
        errors: [
          'External links cannot point to your own domain (subdomains are allowed)',
        ],
        valid: false,
      }
    }
  }

  return validResponse
}

export { externalLink }
